var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-5 text-center"},[_c('div',{staticClass:"py-1"},[_c('b-spinner',{attrs:{"variant":"secondary"}})],1),(_vm.label)?_c('div',[_vm._v(" "+_vm._s(_vm.label)+" ")]):_c('div',[_vm._v(" "+_vm._s(_vm.$t("Loading..."))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }